import { OutlineIcon } from "@lazarentertainment/web-design-system/components/iconCore"
import {
  ComponentPropsWithoutRef,
  forwardRef,
  HTMLInputTypeAttribute,
} from "react"

/**
 * Applies styles to the browser's default <input type="text"/>
 */
export type TextInputProps = Omit<
  ComponentPropsWithoutRef<"input">,
  "type"
> & {
  /**
   * Optionally display an icon in the inner left of the input.
   */
  icon?: OutlineIcon

  /**
   * The type of input to display.
   */
  type?: Extract<
    HTMLInputTypeAttribute,
    "text" | "email" | "password" | "tel" | "number" | "search"
  >
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, icon: Icon, type = "text", ...props }, ref) => {
    return (
      <div className={`text-input-wrapper ${className ?? ""}`}>
        <input
          type={type}
          ref={ref}
          className="text-input body-lg text-color-primary"
          data-with-icon={!!Icon}
          {...props}
        />
        {Icon && <Icon className="text-input-icon" data-size="md" />}
      </div>
    )
  },
)
